var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsObject, IsUUID } from 'class-validator';
import { UserFullSizeDto } from '../../user/index.js';
import { ActivityPointType } from '../enums/activity-point-type.js';
export class ActivityPointTrackingResponseDto {
    id;
    createdAt;
    updatedAt;
    points;
    activityPointType;
    userId;
    user;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ActivityPointTrackingResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ActivityPointTrackingResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ActivityPointTrackingResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ActivityPointTrackingResponseDto.prototype, "points", void 0);
__decorate([
    IsEnum(ActivityPointType),
    Expose(),
    __metadata("design:type", String)
], ActivityPointTrackingResponseDto.prototype, "activityPointType", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ActivityPointTrackingResponseDto.prototype, "userId", void 0);
__decorate([
    Type(() => UserFullSizeDto),
    IsObject(),
    Expose(),
    __metadata("design:type", UserFullSizeDto)
], ActivityPointTrackingResponseDto.prototype, "user", void 0);
//# sourceMappingURL=activity-point-tracking.response.dto.js.map